import { Volume } from "lucide-react";

export const translations = {
    en: {
        Dashboard: "Dashboard",
        Year:"Year",
        Reports:"Reports",
        "Key Performance Indicators":"Key Performance Indicators",
        Suppliers:"Suppliers",
        Count:"Count",
        Active:"Active",
        "Purchase to Final Destination":"Purchase to Final Destination",
        "users":"users",
        "Purchases (Cassiterite)":"Purchase (Cassiterite)",
        "Purchases (Coltan)":"Purchase (Coltan)",
        "Purchases (Copper/Cobalt)":"Purchase (Copper/Cobalt)",
        "Purchases (Wolframite)":"Purchase (Wolframite)",
        "Exports (Cassiterite)":"Export (Cassiterite)",
        "Exports (Coltan)":"Export (Coltan)",
        "Exports (Copper/Cobalt)":"Export (Copper/Cobalt)",
        "Exports (Wolframite)":"Export (Wolframite)",
        "Volume (Kg)":"Volume (Kg)",
    },
    fr: {


        Dashboard: "Tableau de bord",
        Year:"Année",
        Reports:"Rapports",
        "Key Performance Indicators":"Indicateurs Clés de Performance",
        Suppliers:"Fournisseurs",
        Count:"Nombre",
        Active:"Actif",
        "Purchase to Final Destination":"achat à la destination finale",
        "users":"utilisateurs",
        "Purchases (Cassiterite)":"Achat (Cassitérite)",
        "Purchases (Coltan)":"Achat (Coltan)",
        "Purchases (Copper/Cobalt)":"Achat (Cuivre/Cobalt)",
        "Purchases (Wolframite)":"Achat (Wolframite)",
        "Exports (Cassiterite)":"Exportation (Cassitérite)",
        "Exports (Coltan)":"Exportation (Coltan)",
        "Exports (Copper/Cobalt)":"Exportation (Cuivre/Cobalt)",
        "Exports (Wolframite)":"Exportation (Wolframite)",
        "Volume (Kg)":"Volume (Kg)",
        "users":"utilisateurs",

    }
};